"use client";

import React from "react";
import { UsersRound } from "lucide-react";
import { RequestCardGroupProps } from "./RequestGroupCard.types";
import "./RequestCardGroup.css";

function RequestCardGroup<T extends { id: number }>({
  title,
  items,
  renderItem,
  className = "",
  subtitle = "",
  emptyState,
  withBorder = true,
  getKey,
}: RequestCardGroupProps<T>) {
  const groupClass = [
    "request-card-group",
    withBorder ? "with-border" : "no-border",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={groupClass}>
      <h3 className="request-card-group__title" title={subtitle}>{title}</h3>

      <div className="request-card-group__content">
        {items.length === 0 ? (
          <div className="request-card-group__empty">
            {emptyState?.icon || <UsersRound size={36} className="empty-icon" />}
            <p>
              {emptyState?.message ||
                "This space is reserved for your community — it will come together in God's perfect timing."}
            </p>
          </div>
        ) : (

          items.map((item) => {
            const rendered = renderItem(item);
            const key = getKey ? getKey(item) : (item as any).id;
            return rendered ? (
              <div key={key} className="request-card-group__item">
                {rendered}
              </div>
            ) : null;
          })

        )}
      </div>
    </div>
  );
}

export default RequestCardGroup;
